var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Stock Opname"}},[_c('vs-tabs',{attrs:{"value":_vm.active}},[_c('vs-tab',{attrs:{"label":"Complete"}},[_c('div',{staticClass:"tab-text"},[_c('complete-component',{on:{"tab":_vm.setTab}})],1)]),_c('vs-tab',{attrs:{"label":"Ignore"}},[_c('div',{staticClass:"tab-text"},[_c('ignore-component')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }